module.exports = __webpack_public_path__ + "img/sub_step11.28f59e74.png";